import { Checkbox, Grid, Menu, MenuItem, Typography, makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { Add, Delete, Edit, MoreVert } from '@material-ui/icons';
import { useDispatch, useSelector } from 'react-redux';
import Image from '../common/Image';
import { showProgress } from '../../redux/actions/DealershipActions';
import { ErrorToast, notifySuccess, searchArray } from '../utils/Utils';
import service from '../../apis/service';
import { apiEndpoints } from '../../constants/apiEndpoints';
import ZeroState from '../common/ZeroState';
import FileSeachIcon from '../../assets/FileSearchIcon';
import ConfirmationDialog from '../common/ConfirmationDialog';
import DeleteIcon from '../../assets/DeleteIcon';

const useStyle = makeStyles({
  certBox: {
    height: '60vh',
    overflowY: 'auto',
    background: '#F2F4F7',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    padding: '10px 20px',
  },
  header: {
    width: '98%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  add: {
    width: '40px',
    height: '40px',
    color: 'white',
    background: '#622FEE',
    border: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '18px',
    cursor: 'pointer',
  },
  heading: {
    color: '#10182B',
    fontSize: '18px',
    fontWeight: '700',
  },
  inputField: {
    width: '98%',
    padding: '15px 10px',
    borderRadius: '5px',
    border: '1px solid #E4E7EC',
    outline: 'none',
    marginTop: '5px',
    background: '#FEFEFE',
  },
  logo: {
    width: '25%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  checkbox: {
    width: '15%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  titleBox: {
    width: '60%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '5px',
  },
  issuer: {
    width: '46%',
    height: '75px',
    display: 'flex',
    borderRadius: '5px',
    background: '#fefefe',
    border: '1px solid #E4E7EC',
  },
  classList: {
    width: '98%',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    gap: '30px',
  },
});

export const IssuerInfo = ({
  setIsAddIssuer,
  setIsEditIssuer,
  setSelectedIssuer,
  slectedIssuer,
  setCertInfo,
  certInfo,
  isEdit,
}) => {
  const classes = useStyle();
  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = useState(null);
  const [issuerList, setIssuerList] = useState([]);
  const [searchVal, setSearchVal] = useState('');
  const [filteredVal, setFilteredVal] = useState([]);
  const [isConfirmDelete, setIsConfirmDelete] = useState(false);

  const selectedCertInfoEdit = useSelector((state) => state.certificateData.selectedCertInfoEdit);

  const handleClick = (event, id) => {
    setAnchorEl(event.currentTarget);
    setSelectedIssuer(id);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const getIssuerList = async () => {
    dispatch(showProgress(true));
    try {
      const res = await service.get(apiEndpoints.CERT_ALL_ISSUER);
      setIssuerList(res || []);
      setFilteredVal(res || []);
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  useEffect(() => {
    getIssuerList();
  }, []);

  const handleDelete = async () => {
    try {
      await service.delete(apiEndpoints.CERT_ISSUER_DELETE.replace('ID', slectedIssuer));
      notifySuccess('Issuer deleted successfully');
      setAnchorEl(null);
      setIsConfirmDelete(false);
      setSelectedIssuer(null);
      setCertInfo((pre) => ({
        ...pre,
        issuerId: '',
      }));
      getIssuerList();
    } catch (error) {
      ErrorToast(error);
    }
  };

  const handleConfirm = () => {
    setIsConfirmDelete(true);
    setAnchorEl(null);
  };

  useEffect(() => {
    setFilteredVal(issuerList);
  }, [issuerList]);

  const handleSearch = (e) => {
    const searchKey = e.target.value;
    setSearchVal(searchKey);
    const filtered = searchArray(issuerList, ['name'], searchKey);
    setFilteredVal(filtered);
  };

  return (
    <Grid className={classes.certBox}>
      <Grid className={classes.header}>
        <Typography className={classes.heading}>Select Issuer</Typography>
        <Grid className={classes.add}>
          <Add
            onClick={() => {
              setIsAddIssuer(true);
              setIsEditIssuer(false);
            }}
          />
        </Grid>
      </Grid>

      <Grid style={{ width: '98%' }}>
        <input placeholder="Search issuer" className={classes.inputField} value={searchVal} onChange={handleSearch} />
      </Grid>

      {filteredVal?.length > 0 ? (
        <Grid className={classes.classList}>
          {filteredVal?.map((i) => (
            <Grid className={classes.issuer} key={i.id}>
              <Grid className={classes.checkbox}>
                <Checkbox
                  onClick={() => {
                    if (selectedCertInfoEdit?.editWarning && isEdit) {
                      ErrorToast(selectedCertInfoEdit?.editWarning);
                    } else {
                      setCertInfo((pre) => ({
                        ...pre,
                        issuerId: i.id,
                      }));
                    }
                  }}
                  checked={certInfo.issuerId === i.id}
                  style={{ ...(certInfo.issuerId === i.id ? { color: '#622fee' } : {}) }}
                />
              </Grid>
              <Grid className={classes.logo}>
                <Image
                  alt=""
                  src={i.icon}
                  style={{ height: '50px', width: '50px', borderRadius: '50%' }}
                  loading="lazy"
                />
              </Grid>

              <Grid className={classes.titleBox}>
                <Typography noWrap>{i.name}</Typography>
                <div>
                  <MoreVert style={{ cursor: 'pointer' }} onClick={(e) => handleClick(e, i.id)} />
                </div>
              </Grid>
            </Grid>
          ))}

          <Menu
            id="simple-menu"
            keepMounted
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
          >
            <MenuItem
              style={{ justifyContent: 'left' }}
              onClick={() => {
                setIsAddIssuer(false);
                setIsEditIssuer(true);
              }}
            >
              <Edit /> Edit Issuer
            </MenuItem>
            <MenuItem style={{ justifyContent: 'left' }} onClick={handleConfirm}>
              <Delete /> Delete Issuer
            </MenuItem>
          </Menu>
        </Grid>
      ) : (
        <Grid className={classes.classList}>
          <ZeroState
            Icon={FileSeachIcon}
            text="No issuer found. Try searching for something else."
            style={{ paddingBottom: '100px', paddingTop: '30px' }}
            cardWidth="100%"
          />
        </Grid>
      )}

      <ConfirmationDialog
        title="Are you sure you want to delete this Issuer?"
        subText="Once you delete it, you will not be able to recover this issuer."
        onClose={setIsConfirmDelete}
        isOpen={isConfirmDelete}
        confirmFn={handleDelete}
        disagreeText="Cancel"
        agreeText="Delete"
        Icon={DeleteIcon}
        width="500px"
        height="250px"
      />
    </Grid>
  );
};
